module.exports = __webpack_public_path__ + "80aae74275e12c4c834cca2278608161.svg";